import { render, staticRenderFns } from "./StatusFinIdRm.vue?vue&type=template&id=0a76f622"
import script from "./StatusFinIdRm.vue?vue&type=script&lang=js"
export * from "./StatusFinIdRm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports